var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.5H55.625C55.625 7.5 58.125 7.5 58.125 10V50C58.125 50 58.125 52.5 55.625 52.5H4.375C4.375 52.5 1.875 52.5 1.875 50V10C1.875 10 1.875 7.5 4.375 7.5Z",
    fill: "#FF978C",
    fillOpacity: 0.5,
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.875V31.875",
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 41.25C28.125 41.7473 28.3225 42.2242 28.6742 42.5758C29.0258 42.9275 29.5027 43.125 30 43.125C30.4973 43.125 30.9742 42.9275 31.3258 42.5758C31.6775 42.2242 31.875 41.7473 31.875 41.25C31.875 40.7527 31.6775 40.2758 31.3258 39.9242C30.9742 39.5725 30.4973 39.375 30 39.375C29.5027 39.375 29.0258 39.5725 28.6742 39.9242C28.3225 40.2758 28.125 40.7527 28.125 41.25Z",
    fill: "#C12010",
    stroke: "#C12010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitError);
export default __webpack_public_path__ + "static/media/submit-error.586d03abdb7bafb0090eedec82e4a0cb.svg";
export { ForwardRef as ReactComponent };